import React, { useEffect, useState, useCallBack } from 'react';
import { VscLoading } from 'react-icons/vsc';
import { fetchWrapper } from '../../../../_helpers';
import AdminSearchBox from '../../reusableComponents/AdminSearchBox';
import EditPublicGpsCategory from './components/EditPublicGpsCategory';
import PublicGPSItem, { StyledPublicGpsItem } from './components/PublicGPSItem';

function PublicGps() {
	const [publicChannels, setPublicChannels] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [search, setSearch] = useState();
	const [show, setShow] = useState(false);

	const handleClose = () => {
		setShow(false);
	};

	useEffect(() => {
		const getPublicChannels = async () => {
			try {
				setIsLoading(true);
				const response = await fetchWrapper.get(`/chatrooms/publicgps/${search ? `?title=${search}` : ''}`);
				setPublicChannels(response);
				setIsLoading(false);
			} catch (error) {
				setIsLoading(false);
			}
		};
		if (show === false) {
			getPublicChannels();
		}
	}, [search, show]);

	const onSearch = (value) => {
		setSearch(value);
	};

	return (
		<div>
			<div className="d-flex justify-content-between">
				<div>
					<span>All Public channels</span>
				</div>
				<div>
					<AdminSearchBox search={search} onSearch={onSearch} placeholder={'Enter Public gps channel name'} />
				</div>
			</div>
			<StyledPublicGpsItem className="heading">
				<div className="d-flex team">
					<div className="mx-4">
						<div className="font-weight-bold">{'Channel'}</div>
						<div className="small">team: {'Team'}</div>
					</div>
				</div>
				<div className="mr-4 category">Category</div>
				<div className="buttons">Actions</div>
			</StyledPublicGpsItem>
			<div>
				{isLoading ? (
					<div className="w-100 d-flex justify-content-center align-items-center m-4">
						<VscLoading className="spin" fontSize="34" />
					</div>
				) : (
					publicChannels?.map((channel) => (
						<PublicGPSItem key={channel.id || channel._id} channel={channel} setShow={setShow} />
					))
				)}
			</div>
			{show && <EditPublicGpsCategory show={show} handleClose={handleClose} />}
		</div>
	);
}

export default PublicGps;
